(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "696616e2957aa960840d5b63";
              window.beaePageSetting.pageTitle = "Hair Loss Shampoo & Scalp Health Insights"; 
              window.beaePageSetting.pageType = "blog";

          let js_1CE7SOGO = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-td9z5b4vsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-td9z5b4v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-td9z5b4v');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-td9z5b4v: ', ex)
      };
    

      try {
        let argid = 'beae-o0ayz1asblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-o0ayz1as',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-o0ayz1as');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-o0ayz1as: ', ex)
      };
    

      try {
        let argid = 'beae-fsxlqrwcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fsxlqrwc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fsxlqrwc');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fsxlqrwc: ', ex)
      };
    

      try {
        let argid = 'beae-rsgv0n79section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rsgv0n79',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rsgv0n79');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rsgv0n79: ', ex)
      };
    

      try {
        let argid = 'beae-2dcu2h88section-blog-posts-page',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2dcu2h88',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2dcu2h88');
        args.el = args.els[0];
        ((a) => { var g;n();function n(){document.querySelectorAll(".beae-blog-paginate--wrp a").forEach(u=>{(!u.hasAttribute("href")||!u.getAttribute("href").trim())&&(u.addEventListener("click",function(f){f.preventDefault()}),u.classList.add("disabled"),u.style.pointerEvents="none",u.style.opacity="0.5")})}const t=window.location.search,o="/blogs/"+((g=a.blog)==null?void 0:g.handle),r=a.el.querySelectorAll(".beae-blog-list button.beae-blog-btn"),s=a.el.querySelectorAll(".beae-blog-list button.beae-blog-tag-btn");r.length>0&&c(r,t),s.length>0&&c(s,t,o),d();const p=a.el.querySelector(".beae-x-blog-posts-page");function c(h,u="",f=""){if(h.length){const b=window.location.pathname;h.forEach(C=>{C.getAttribute("data-url")===b&&C.classList.add("active"),C.addEventListener("click",function(m){var B;h.forEach(k=>{k.classList.remove("active")}),C.classList.add("active");const _=f+((B=C.getAttribute("data-url"))==null?void 0:B.replace(" ","-"));if(!_)return;const S=new URL(window.location.origin+_+u);y(S.href)})})}}function d(){const h=document.querySelectorAll(".beae-blog-paginate .beae-blog-pagination-btn");h.length&&h.forEach(u=>{u.addEventListener("click",function(f){const b=u.getAttribute("data-url");if(!b)return;const C=new URL(window.location.origin+b);y(C.href)})})}let l={};function v(h,u){return new Promise(f=>{const b=a.el.querySelector(u),C=document.createElement("div");C.innerHTML=h;const m=C.querySelector(u);b&&(b.style.height="fit-content",m?b.innerHTML=m.innerHTML:(b.style.height="0px",b.style.overflow="hidden")),f()})}function y(h){if(l={},!p)return;const u=p.getAttribute("section-template-id"),f=new URL(h);let b=f.search?f.search.replace("?",""):"";const C=f.pathname+"?section_id="+u+"&"+b;fetch(C).then(m=>m.text()).then(m=>{l[C]=m,v(m,".beae-x-blog-posts"),v(m,".beae-blog-paginate"),d()}),history.pushState({searchParams:b},"",`${f.pathname}${b&&"?".concat(b)}`)} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2dcu2h88: ', ex)
      };
    

      try {
        let argid = 'beae-em47v2ctblock-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-em47v2ct',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-em47v2ct');
        args.el = args.els[0];
        ((data
) => { data.el.querySelectorAll('.beae-blog-tag-btn').forEach(button => {
    const url = button.getAttribute('data-url');
    if (url === '/tagged/') {
      button.setAttribute('data-url', '/');
    
    }
    if (button.getAttribute('data-url') === '/') {
      button.classList.add('active');
    }
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-em47v2ct: ', ex)
      };
    

      try {
        let argid = 'beae-fx0bdz94block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fx0bdz94',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fx0bdz94');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),z,R=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(I){let A=0,D;j(),R?H.onmouseover=function(W){q(W)}:I.onmousedown=function(W){q(W)},H.onmouseup=function(){Z()},I.ontouchstart=function(W){q(W)},H.ontouchend=function(){Z()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=T.offsetWidth})}).observe(T),I.style.left&&parseInt(I.style.left)}function q(W){check=!1,W.preventDefault(),W.clientX?W.clientX:W.touches[0].clientX,parseInt(I.style.left),A=1,H.onmousemove=function(Y){F(Y)},H.ontouchmove=function(Y){F(Y)}}function Z(){A=0,check=!0}function F(W){if(A==0)return!1;D=U(W),D<0&&(D=0),D>100&&(D=100),G(D)}function U(W){const Y=H.getBoundingClientRect(),oe=(W.changedTouches?W.changedTouches[0].clientX:W.clientX)-Y.left;return Math.max(0,Math.min(100,Math.round(oe*100/z)))}function G(W){I.style.left=W+"%",T.style.clipPath=`polygon(${W}% 0%, ${W}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${W}% 0%, ${W}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let z=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(z)return z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fx0bdz94: ', ex)
      };
    

      try {
        let argid = 'beae-16iebqfcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-16iebqfc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-16iebqfc');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-16iebqfc: ', ex)
      };
    

      try {
        let argid = 'beae-ofbxolqzblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ofbxolqz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ofbxolqz');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ofbxolqz: ', ex)
      };
    

      try {
        let argid = 'beae-yf776oyyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-yf776oyy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-yf776oyy');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-yf776oyy: ', ex)
      };
    

      try {
        let argid = 'beae-ui5cg66mblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ui5cg66m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ui5cg66m');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ui5cg66m: ', ex)
      };
    

      try {
        let argid = 'beae-4bpmqqejsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4bpmqqej',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4bpmqqej');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4bpmqqej: ', ex)
      };
    }; if (window.BEAEBASE) {js_1CE7SOGO()} else {window.BEAEPAGEJS.push(js_1CE7SOGO)} })(); 